import { render, staticRenderFns } from "./Approval.vue?vue&type=template&id=12d43f28&"
import script from "./Approval.vue?vue&type=script&lang=js&"
export * from "./Approval.vue?vue&type=script&lang=js&"
import style0 from "./Approval.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12d43f28')) {
      api.createRecord('12d43f28', component.options)
    } else {
      api.reload('12d43f28', component.options)
    }
    module.hot.accept("./Approval.vue?vue&type=template&id=12d43f28&", function () {
      api.rerender('12d43f28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/hotb/Approval.vue"
export default component.exports